import React, { Suspense, useState } from "react";
import { Switch, Route } from "react-router-dom";

import Header from "./components/Header/Header";
import Main from "./containers/Main";
import Footer from "./components/Footer/Footer";
import classes from "./App.module.css";

const Watch = React.lazy(() => import("./containers/Watch"));
const WatchTV = React.lazy(() => import("./containers/WatchTV"));
const Movies = React.lazy(() => import("./containers/Movies"));
const Series = React.lazy(() => import("./containers/Series"));

const App = props => {
  const [isSearching, setIsSearching] = useState(false);
  const [keyword, setKeyword] = useState("");

  const searchHandler = event => {
    setIsSearching(true);
    const val = event.target.value;
    setKeyword(val);
    if (val.length === 0) {
      setIsSearching(false);
    }
    console.log(`SEARCHING: ${isSearching} WORD: ${val}`);
  };

  return (
    <React.Fragment>
      <div className={classes.App}>
        <div className={classes.BgCover}></div>
        <div className={classes.Wrapper}>
          <div className={classes.ContentWrapper}>
            <Header onSearching={searchHandler} />
            <Suspense fallback="Yükleniyor...">
              <Switch>
                <Route
                  path="/film/:id"
                  render={() => (
                    <Watch searching={isSearching} keyword={keyword} />
                  )}
                />
                <Route
                  path="/dizi/:id"
                  render={() => (
                    <WatchTV searching={isSearching} keyword={keyword} />
                  )}
                />
                <Route
                  path="/filmler"
                  render={() => (
                    <Movies searching={isSearching} keyword={keyword} />
                  )}
                />
                <Route
                  path="/diziler"
                  render={() => (
                    <Series searching={isSearching} keyword={keyword} />
                  )}
                />
                <Route path="/">
                  <Main searching={isSearching} keyword={keyword} />
                </Route>
              </Switch>
            </Suspense>
            <Footer />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default App;
